export const formatResponseError = (error) => {
	const responseError = error?.response?.data?.error

	if (responseError) {
		const formattedError = new Error(responseError?.message)
		Object.keys(responseError).forEach((prop) => {
			formattedError[prop] = responseError[prop]
		})
		return formattedError
	}
	console.error(error?.message ?? error)
	const unexpectedError = new Error('Unexpected Error')
	return unexpectedError
}
